(function ($) {

    function addColoredSvgsClasses() {
        $('svg.svg-colored').each(function() {
            const $thisSvg = $(this);

            $thisSvg.find('path, circle, rect').each(function() {
                const $thisChildEl = $(this);

                let classesToAdd = '';

                if ($thisChildEl.attr('stroke')) {
                    classesToAdd = 'icon-stroke';
                }
                else if ($thisChildEl.attr('fill')) {
                    classesToAdd = 'icon-fill';
                }

                $thisChildEl.addClass(classesToAdd);
            });
        })
    }

    $(document).on('ready', function () {
        addColoredSvgsClasses();
    });


    $(document).on('toc:initialized', function () {
        addColoredSvgsClasses();
    });


})(jQuery);